export const COEFFICIENTS = {
  age: -0.0448,
  sex: 0.2667,
  eGFR: -0.0502,
  hemo: -0.0164,
  albuminuriaMild: 0.4352,
  albuminuriaHeavy: 0.8742,
  diabetes: 0.3163,
  priorInv: -0.0378,
  interTerm: -7.1358
};

export const BASELINES = {
  age: -73.62,
  eGFR: -51.12,
  hemo: -130.95
};

export const FACTOR = {
  conservativeMgmt: 1 / 1.20
};
